<template>
  <element>
    <AppBar :title="$t('feedbackPage.title')" />
    <v-container>
      <FeedbackTable />
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import FeedbackTable from "@/components/feedback/FeedbackTable.vue"

export default {
  name: "FeedbackPage",
  components: {
    AppBar,
    FeedbackTable
  },
  data() {
    return {
      feedbacks: []
    }
  },
  methods: {

  },
}
</script>

<style scoped>

</style>